import React from 'react';
import { Col, Table } from 'react-bootstrap';

const SuccessScoreTable = ({ scores }) => {
	const totalScore = scores
		.filter(score => score.total_points !== -1)
		.reduce((sum, score) => sum + score.total_points, 0);

	return (
		<Col>
			<Table responsive className="table-lg" style={{ fontSize: '0.9rem', marginTop: 5, marginBottom: 5 }}>
				<thead>
					<tr>
						<th style={{ padding: '15px' }}>Section</th>
						<th style={{ padding: '15px', textAlign: 'center' }}>Your score</th>
					</tr>
				</thead>
				<tbody>
					{scores.map((score, i) => (
						<tr key={i} style={{ backgroundColor: "#f8f9fa" }}>
							<td style={{ padding: "15px" }}>{score.section_name}</td>
							<td style={{ textAlign: "center", padding: "15px" }}>
								{score.total_points === -1 ? (
									<span className="text-muted fw-semibold">Pending</span>
								) : (
									<strong>{score.total_points}</strong>
								)}
							</td>
						</tr>
					))}
					<tr className="bg-white border-top border-3">
						<td style={{ padding: "15px", fontWeight: "bold" }}>Total</td>
						<td style={{ textAlign: "center", fontWeight: "bold", padding: "15px" }}>{totalScore}</td>
					</tr>
				</tbody>
			</Table>
		</Col>
	);
};

export default SuccessScoreTable;